module.exports = __webpack_public_path__ + "static/media/attack-number-3.4b64d943.png";